// common/services/player/resendFamilyContact.ts
import req from '../../api/request'
import { ENDPOINTS } from '../../api/endpoints'
import type { FamilyScope } from './familyScope'

export type ResendFamilyContactInput = {
  /**
   * Player whose family the contact belongs to. Not part of the resend URL
   * (the invitation id alone identifies it) — kept so the hook can invalidate
   * the player's family-list cache on success.
   */
  playerId: string
  /** The invitation id — same value as the family contactId — being resent. */
  contactId: string
  /**
   * Not part of the resend URL either — this route is the same on every
   * surface. Carried purely so the hook invalidates the family list under the
   * scope the caller actually read it from.
   */
  scope?: FamilyScope
}

export type ResendFamilyContactResponse = {
  id?: string
  status?: string
} & Record<string, unknown>

/**
 * GET /invitations/:contactId/resend — re-sends a pending family-contact
 * invitation email (the invitation id is the family contactId). Side-effecting
 * GET per the backend contract; only meaningful for contacts that have not yet
 * accepted. The base URL already includes /v1.
 */
export const resendFamilyContact = async (
  input: ResendFamilyContactInput
): Promise<ResendFamilyContactResponse> => {
  const { contactId } = input
  const { data } = await req(
    ENDPOINTS.PLAYERS.RESEND_PLAYER_FAMILY_INVITE(contactId),
    { method: 'GET' }
  )
  return data as ResendFamilyContactResponse
}
